import { render, staticRenderFns } from "./ArticleRewardList.vue?vue&type=template&id=d5c04fb6&scoped=true&"
import script from "./ArticleRewardList.vue?vue&type=script&lang=js&"
export * from "./ArticleRewardList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRewardList.vue?vue&type=style&index=0&id=d5c04fb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c04fb6",
  null
  
)

export default component.exports